<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PostSaleCasesTableTags from './PostSaleCasesTableTags.vue';
import { formatPostSaleDate } from './postSaleCasesTablePresenter';

const props = defineProps({
  item: { type: Object, required: true },
  list: { type: String, required: true },
});

const { t } = useI18n();

const terminalDate = computed(() =>
  props.list === 'cancelados' ? props.item.canceled_at : props.item.completed_at
);
</script>

<template>
  <td class="p-3 align-top">
    {{ formatPostSaleDate(terminalDate) || t('POST_SALE.COMMON.NO_DATE') }}
  </td>
  <td class="p-3 align-top">
    <PostSaleCasesTableTags
      :items="item.table?.payment_methods"
      type="payments"
    />
  </td>
  <td class="p-3 align-top">
    <PostSaleCasesTableTags :items="item.table?.laudemiums" type="laudemiums" />
  </td>
  <td class="p-3 align-top">
    <span
      class="rounded-full bg-lais-bg-soft px-2 py-1 text-xs font-semibold text-lais-text-body"
    >
      {{ item.manager?.name || t('POST_SALE.COMMON.UNASSIGNED') }}
    </span>
  </td>
</template>
